export class ImportFileValidationError {

  public fieldName: string;
  public fieldValue: string;
  public type: ImportValidationErrorType;

  static fromDto(data: any): ImportFileValidationError {
    if (!data) {
      return null;
    }

    const parseError = new ImportFileValidationError();

    parseError.fieldName  = data.field_name;
    parseError.fieldValue = data.field_value;
    parseError.type       = data.message;

    return parseError;
  }
}

export enum ImportValidationErrorType {

  EMPTY                    = 'NULL',
  NOT_EMPTY                = 'NOT_NULL',
  INVALID_FORMAT           = 'INVALID_FORMAT',
  INVALID_DATE_FORMAT      = 'INVALID_DATE_FORMAT',
  INVALID_LATITUDE_FORMAT  = 'INVALID_LATITUDE_FORMAT',
  INVALID_LONGITUDE_FORMAT = 'INVALID_LONGITUDE_FORMAT'
}
